
import type { ComponentType } from "react";
import {
  Braces,
  Columns3,
  FunctionSquare,
  GitBranch,
  Images,
  Layers,
  Link2,
  Replace,
  Route,
  Sparkles,
  Square,
  Tags,
  Type,
  Variable,
} from "lucide-react";
import type { ModuleIcon } from "@/lib/mapper/modules/catalog";
import {
  AnthropicIcon,
  DropboxIcon,
  GoogleIcon,
  OpenAIIcon,
  ShopifyIcon,
} from "./brands";

type IconProps = {
  className?: string;
  size?: number;
};

const LUCIDE_ICONS: Record<string, ComponentType<IconProps>> = {
  Columns3,
  Type,
  Braces,
  FunctionSquare,
  GitBranch,
  Sparkles,
  Variable,
  Images,
  Layers,
  Replace,
  Route,
  Tags,
  Link2,
};

const BRAND_ICONS: Record<
  Extract<ModuleIcon, { kind: "brand" }>["name"],
  ComponentType<IconProps>
> = {
  openai: OpenAIIcon,
  anthropic: AnthropicIcon,
  dropbox: DropboxIcon,
  shopify: ShopifyIcon,
  google: GoogleIcon,
};

export function ModuleIconView({
  icon,
  className,
  size = 16,
}: {
  icon: ModuleIcon;
  className?: string;
  size?: number;
}) {
  const Icon =
    icon.kind === "brand"
      ? BRAND_ICONS[icon.name]
      : LUCIDE_ICONS[icon.name] ?? Square;

  return <Icon className={className} size={size} />;
}
